import React from 'react';

export default function SecurityStatusPill({ active, activeLabel = 'Active', inactiveLabel = 'Inactive' }) {
  return (
    <span className={`vx-sec-status-pill ${active ? 'vx-sec-status-pill--active' : 'vx-sec-status-pill--inactive'}`}>
      <span className="vx-sec-status-dot" aria-hidden="true" />
      {active ? activeLabel : inactiveLabel}
    </span>
  );
}
